import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { thunks } from 'services/thunks';
import { NoOrders } from 'ui/components/molecules/Driver/OrderBoard/NoOrders';
import { CompletedOrdersTableRow } from 'ui/components/organisms/Driver/OrderBoard/CompletedOrdersTableRow';
import { withCommonLoading } from 'ui/hoc/withCommonLoading';
import { Pagination } from 'ui/components/organisms/Driver/OrderBoard/Pagination';
import injectSheet from 'react-jss';
import { openOrders } from 'ui/styles/Driver/OrderBoard/openOrders';

const mapStateToProps = state => ({
  completedOrders: state.getIn(['app', 'driver', 'completedOrders']),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCompletedOrders: thunks.getCompletedOrders,
    },
    dispatch,
  );

class _CompleteOrders extends React.Component {
  componentDidMount() {
    const { getCompletedOrders, endLoading } = this.props;
    getCompletedOrders(1, endLoading);
  }

  render() {
    const {
      classes,
      completedOrders,
      isLoading,
      getCompletedOrders,
      isMobile,
    } = this.props;
    if (isLoading || completedOrders.get('items').size === 0) {
      return <NoOrders />;
    }
    return (
      <div className={classes.container}>
        <div className={classes.table}>
          {completedOrders.get('items').map(order => (
            <CompletedOrdersTableRow
              key={order.get('orderId')}
              data={order}
              isMobile={isMobile}
            />
          ))}
        </div>
        <Pagination
          activeOrders={completedOrders}
          getActiveOrders={getCompletedOrders}
        />
      </div>
    );
  }
}

export const CompleteOrders = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withCommonLoading(),
  injectSheet(openOrders),
)(_CompleteOrders);
